import {createAction} from '@reduxjs/toolkit'

export const clearReservationError = createAction<boolean>('CLEAR_RESERVATION_ERROR')
